import React, { useEffect, useState } from 'react'
import { Icon } from 'components/images/icons'
import styled, { useTheme } from 'styled-components'

// Visually hidden but accessible to screen readers and keyboard navigation
const HiddenField = styled.input.attrs({ type: 'checkbox' })`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const VisualLabel = styled.label`
  ${({ theme: { colors, defaults, font } }) => `
    font-weight: 500;
    font-size: ${font('md')};
    color: ${colors('text')};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: ${defaults('padding')} 0;
    cursor: pointer;
    user-select: none;
  `}
`

const CheckBox = styled.div`
  ${({ $checked, theme: { colors, defaults } }) => `
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    width: ${defaults('height') / 2.7}rem;
    height: ${defaults('height') / 2.7}rem;
    margin: 0 ${defaults('padding')};
    border: 1px solid ${$checked ? colors('link') : colors('neutral')};
    background: ${$checked ? colors('link') : 'transparent'};
    border-radius: 2px;
    transition: background 0.15s, border-color 0.15s;
  `}
`

const Checkboxes = styled.div`
  ${({ theme: { defaults, breakpoint } }) => `
    display: grid;
    margin: ${defaults('margin')};
    @media screen and (min-width: ${breakpoint('sm')}) {
      grid-template-columns: 1fr 1fr;
    }
    @media screen and (min-width: ${breakpoint('md')}) {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
  `}
`

export const Checkbox = ({
  name,
  onChange = () => {},
  label,
  value,
  checked
}) => {
  const { colors } = useTheme()

  return (
    <>
      <HiddenField
        id={name}
        name={name}
        onChange={onChange}
        value={value}
        checked={checked}
      />
      <VisualLabel htmlFor={name}>
        <CheckBox $checked={checked}>
          {checked && (
            <Icon icon="check" fill={colors('foreground')} stroke={colors('foreground')} />
          )}
        </CheckBox>
        {label}
      </VisualLabel>
    </>
  )
}

export const CheckboxGroup = ({ data = [], name, onChange }) => {
  const [selections, setSelections] = useState([])

  useEffect(() => {
    return onChange({ target: { name, value: selections } })
  }, [selections])

  const handler = ({ target }) => {
    if (!target.checked) {
      setSelections(selections.filter((selection) => target.value !== selection))
    } else {
      setSelections([...selections, target.value])
    }
  }

  return (
    <Checkboxes>
      {data.map((check) => (
        <Checkbox
          key={check.value}
          name={check.value}
          label={check.label}
          onChange={handler}
          value={check.value}
          checked={selections.includes(check.value)}
        />
      ))}
    </Checkboxes>
  )
}
